var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldHierarchySquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zM7.8 18.5c-1.13 0-2.05-.92-2.05-2.05 0-.87.54-1.6 1.3-1.9v-4.29A2.202 2.202 0 0 1 5.6 8.2c0-1.21.99-2.2 2.2-2.2 1.21 0 2.2.99 2.2 2.2 0 .95-.61 1.75-1.45 2.06v4.29c.76.3 1.3 1.04 1.3 1.9 0 1.13-.92 2.05-2.05 2.05zm6.9-2.05c0-.87.54-1.6 1.3-1.9v-5.8c0-.14-.11-.25-.25-.25h-1.13l.21.17c.32.27.36.74.1 1.06a.759.759 0 0 1-1.06.1l-1.8-1.5a.777.777 0 0 1-.27-.58c0-.22.1-.43.27-.58l1.8-1.5c.32-.26.79-.22 1.06.1s.22.79-.1 1.06l-.21.17h1.13c.96 0 1.75.79 1.75 1.75v5.8c.76.3 1.3 1.04 1.3 1.9 0 1.13-.92 2.05-2.05 2.05s-2.05-.92-2.05-2.05z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldHierarchySquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-hierarchy-square.2cc5af928f64e2b6c30ec71c4443dc4d.svg";
export { ForwardRef as ReactComponent };